import { useCallback, useState } from "react";
import { useCookies } from "react-cookie";
import { STORAGE_PREFIX } from "../../config";

export const useLocalStorage = (_key: string, _initialValue: any) => {
  const [cookies, setCookie, removeCookie] = useCookies();
  const key = STORAGE_PREFIX + _key

  const initialValue = () => {
    try {
      const item = cookies[key]
      return item ? item : _initialValue
    } catch (error) {
      return _initialValue
    }
  }

  const [storedValue, setStoredValue] = useState(initialValue())

  // Migração (OP-3462): versões antigas gravavam sem path (= diretório da
  // página), criando cookies duplicados em subárvores (/interno, /events/123…)
  // que sombreiam o cookie canônico em '/'. Remove o nome em todos os paths
  // ancestrais da página atual — no-op inofensivo quando não existem.
  const removeStalePathCookies = useCallback(() => {
    const segmentos = window.location.pathname.split('/').filter(Boolean)
    let dir = ''
    segmentos.forEach((seg) => {
      dir += '/' + seg
      removeCookie(key, { path: dir })
    })
  }, [key, removeCookie])

  // path: '/' SEMPRE (OP-3462): sem path explícito o navegador usa o diretório
  // da página atual — um setValue disparado em /interno (ex.: refresh do token)
  // criava um SEGUNDO cookie com Path=/interno que sombreava o login novo nas
  // rotas do BD Interno (e o remove sem path não o apagava).
  const setValue = useCallback(
    (value: any) => {
      try {
        const valueToStore =
          value instanceof Function ? value(storedValue) : value
        setStoredValue(valueToStore)
        removeStalePathCookies()
        setCookie(key, JSON.stringify(valueToStore), { path: '/' })
      } catch (error) {
        console.error('error', error);
      }
    },
    [key, storedValue, setCookie, removeStalePathCookies]
  );

  const removeValue = useCallback(
    () => {
      try {
        removeStalePathCookies()
        removeCookie(key, { path: '/' })
      } catch (error) {
        console.error('error', error);
      }
    },
    [key, removeCookie, removeStalePathCookies]
  );

  return [storedValue, setValue, removeValue]
}